<template>
  <transactions-table url="/api/v1/cryptoTransactions" show-user-details />
</template>
<script>
import TransactionsTable from "./table";

export default {
  components: { TransactionsTable },
};
</script>
